import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ChevronLeft } from 'lucide-react';
import { API } from '@/constants/data';

const PrivacidadePage = () => {
  const [sections, setSections] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings/privacy_sections`).then(r => {
      if (r.data.value && r.data.value.length > 0) setSections(r.data.value);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  const defaultSections = [
    { title: '1. Coleta e Uso de Dados', content: 'Ao preencher qualquer formulário neste site (contato, orçamento ou candidatura), você fornece voluntariamente dados como nome, email, telefone e informações profissionais. Esses dados são coletados e armazenados pelo Grupo Tomaselli com a finalidade exclusiva de atender sua solicitação, manter comunicação comercial e conduzir processos seletivos internos.' },
    { title: '2. Consentimento', content: 'Ao enviar suas informações através dos formulários deste site e aceitar esta Política de Privacidade, você consente expressamente com a coleta, armazenamento e uso dos seus dados para as finalidades aqui descritas, pelo prazo necessário ao atendimento da sua solicitação e manutenção do relacionamento comercial ou profissional.' },
    { title: '3. Armazenamento', content: 'Seus dados são armazenados em ambiente digital seguro, com acesso restrito à equipe autorizada do Grupo Tomaselli. Os dados serão mantidos enquanto houver finalidade legítima para o seu tratamento ou conforme exigido pela legislação aplicável.' },
    { title: '4. Compartilhamento', content: 'O Grupo Tomaselli não vende, aluga ou compartilha seus dados pessoais com terceiros para fins comerciais. Dados poderão ser compartilhados apenas em caso de obrigação legal ou para proteção dos direitos da empresa.' },
    { title: '5. Cookies', content: 'Este site utiliza apenas cookies essenciais para o seu funcionamento. Não utilizamos cookies de rastreamento, publicidade ou análise comportamental de terceiros.' },
    { title: '6. Disposições Gerais', content: 'Esta política está em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018). O Grupo Tomaselli reserva-se o direito de atualizar esta política a qualquer momento, sendo a versão vigente sempre a publicada nesta página.' },
    { title: '7. Contato', content: 'Para dúvidas relacionadas a esta política: Email: adm@grupotomaselli.com | Telefone: (92) 98802-0092' },
  ];

  const displaySections = sections.length > 0 ? sections : defaultSections;

  return (
    <div className="pt-20 min-h-screen bg-white" data-testid="privacidade-page">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
        <Link to="/" className="text-[#00A8E8] mb-8 inline-flex items-center gap-1 font-body font-bold"><ChevronLeft size={14} /> Voltar</Link>
        <h1 className="font-heading text-4xl text-[#0A2463] uppercase mb-8">Política de Privacidade</h1>
        <div className="text-[#475569] leading-relaxed font-body space-y-6 text-sm">
          <p><strong>Última atualização:</strong> Março de 2026</p>
          {displaySections.map((sec, i) => (
            <div key={i}>
              <h2 className="text-[#0A2463] font-heading text-xl uppercase mt-8">{sec.title}</h2>
              <p className="whitespace-pre-line">{sec.content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacidadePage;
